<template>
 <div>
    <div class="video_wrapper">
      <div class="video_block">
        <video-wrapper ref="player"
                        :controls="vimeoControlStatus"
                        :player="'vimeo'"
                        :videoId="videoId"
                        @loaded="handleLoaded"
                        @play="setCaptureTimestamp"
                        @pause="setPauseStatus"
                        @cuepoint="setWebcamCapture"
                        @ended="setEndedWebcamCapture"
                        @progress="saveCurrentProgress"
        />
      <div v-if="!vimeoControlStatus" class="video_overlay_wrapper"></div>
      </div>
    </div>
    <div class="col-md-12 video-play">
      <div v-if="!vimeoControlStatus" class="videoPlayPauseBtn text-center">
          <button class="btn btn-primary mr-2 btn__player-custom" id="seekBtn" @click="setSeekBackward" data-toggle="tooltip" data-placement="top" title="30s Backward"><img  src="https://img.icons8.com/external-android-line-2px-amoghdesign/22/ffffff/external-backward-multimedia-line-24px-android-line-2px-amoghdesign.png"/></button>
          <button class="btn btn-primary btn__player-custom" id="playpauseBtn" @click="setPlayPauseBtn" data-toggle="tooltip" data-placement="top" title="Play"><img  v-if="isPaused" src="https://img.icons8.com/material/22/ffffff/play--v1.png"/><img  v-if="!isPaused" src="https://img.icons8.com/material/22/ffffff/pause--v3.png"/></button>
          <button class="btn btn-primary ml-2 btn__player-custom" id="seekBtn" @click="setSeek" data-toggle="tooltip" data-placement="top" title="30s Forward"><img  src="https://img.icons8.com/material-outlined/22/ffffff/fast-forward.png"/></button>
          <button class="btn btn-primary ml-2 btn__player-custom" id="responsiveBtn" @click="setResponsiveBtn" data-toggle="tooltip" data-placement="top" title="Maximize"><img  src="https://img.icons8.com/material/22/ffffff/full-screen--v1.png"/></button>
          <button class="btn btn-primary ml-2 btn__player-custom" id="responsiveBtn" @click="setToStart" data-toggle="tooltip" data-placement="top" title="Watch Beginning"><img  src="https://img.icons8.com/ios/22/ffffff/rollback.png"/></button>
      </div>
    </div>
    <div class="col-md-12 video-play my-1">
      <div v-if="!vimeoControlStatus" class="videoPlayPauseBtn text-center">
        <input type="range" @change="setProgress" id="volume" name="volume" min="0" :max="videoDuration" v-model="counterValue" data-toggle="tooltip" data-placement="top" :title="counterValue+'s'"><span class="custom-player__time-duration--text ml-2">{{counterValue | formatTime}}/{{videoDuration | formatTime}}</span>
      </div>
    </div>
    <div class="webcam_wrapper">
      <Webcam v-if="showWebcam" @showWebcam="showHideWebcam" :showWebcam="showWebcam" :captureCount="captureCount" :captureMode="'video'"></Webcam>
    </div>
  </div>
</template>

<script>
import Webcam from '@/components/template/Webcam'
import { isMobile } from "mobile-device-detect";
var $ = require('jquery')
var Cookies = require('vue-cookies')
var userPermissions = Cookies.get('userPermissions')
var Config = require('../../router/Config')

export default {
  components: { Webcam },
  name: 'Vimeovideo',
  props: ['videoId'],
  data () {
    return {
      // vimeoControlStatus: (Config.clientFeature) ? Config.clientFeature.vimeoControls : true,
      vimeoControlStatus: false,
      topicVideoFaceCapture: false,
      // topicVideoFaceCapture: (Config.clientFeature) ? Config.clientFeature.topicVideoFaceCapture : true,
      videoDuration: 0,
      imageCount: 4,
      captureCount: 0,
      pauseTimestamp: 0,
      showWebcam: false,
      isSetCues: false,
      isVideoEnded: false,
      isPaused: true,
      isPlaying: false,
      isMobile: isMobile,
      clientId: '',
      videoName: 'videoProgress_',
      constraints: {
        audio: false,
        video: { width: 1280, height: 720 }
      },
      counterValue: 0
    }
  },
  beforeCreate: function () {
    if (!userPermissions.course_view) {
      this.$router.push('/')
    }
  },
  beforeMount: function () {
    this.videoName += this.videoId

    if (userPermissions.video_features_panel) {
      this.vimeoControlStatus = true
    } else {
      if (isMobile) {
        this.vimeoControlStatus = true
      }
    }

    if (userPermissions.topic_video_face_capture) {
      this.topicVideoFaceCapture = true
    }
  },
  mounted () {
    this.clientId = Cookies.get('clientId')
  },
  computed: {
    player () {
      return this.$refs.player.player
    }
  },
  methods: {
    handleLoaded () {
      var prg = Cookies.get(this.videoName)
      if(prg > 0) {
        this.player.setCurrentTime(prg)
        this.counterValue = prg
      }
      this.getDuration()
    },
    setPauseStatus () {
      var self = this
      // console.log('Video Paused')
      this.player.getCurrentTime().then(function (seconds) {
        self.counterValue = seconds
        Cookies.set(self.videoName, seconds)
      }).catch(function (error) {
        console.error(error)
      });
      this.isPaused = true
      this.isPlaying = false
    },
    setPlayPauseBtn () {
      // console.log('Play Pause btn pressed')
      if (this.isPaused) {
        this.player.play()
      } else {
        this.player.pause()
      }
    },
    setResponsiveBtn () {
      this.player.requestFullscreen()
    },
    setSeek () {
      var self = this
      this.player.getCurrentTime().then(function (seconds) {
        self.player.setCurrentTime(seconds+30)
      }).catch(function (error) {
        console.log(error)
      })
    },
    setSeekBackward () {
      var self = this
      this.player.getCurrentTime().then(function (seconds) {
        self.player.setCurrentTime(seconds-30)
      }).catch(function (error) {
        console.log(error)
      })
    },
    getDuration () {
      var self = this
      this.$refs.player.player.getDuration().then(function (duration) {
        self.videoDuration = duration
      })
    },
    setCaptureTimestamp () {
      this.isVideoEnded = false
      this.isPaused = false
      this.isPlaying = true
      if (this.topicVideoFaceCapture) {
        if (!this.isSetCues) {
          var timeSlot = parseInt(this.videoDuration / this.imageCount)
          this.isSetCues = true
          for (let index = 0; index < this.imageCount; index++) {
            var randomTimeSlot = Math.floor(Math.random() * timeSlot + 1)
            var pauseTime = this.pauseTimestamp + randomTimeSlot
            this.pauseTimestamp += timeSlot
            console.log(pauseTime)

            this.player.addCuePoint(pauseTime, {
              customKey: 'pauseTimeslot' + index
            })
          }
        }
      }
    },
    setWebcamCapture (event) {
      var self = this
      navigator.mediaDevices.getUserMedia(this.constraints).then(function (stream) {
        self.player.pause()
        self.showWebcam = true
        self.captureCount++
        Cookies.set('captureCount', self.captureCount)
        console.log('webcam started for image no: ' + self.captureCount + ' : time: ' + event.time)
      }).catch(function (err) {
        console.log(err)
      })
    },
    showHideWebcam (status) {
      this.showWebcam = status
      if (!this.isVideoEnded) {
        this.player.play()
      } else {
        var self = this
        this.player.getCuePoints().then(function (cuePoints) {
          // console.log('cuepoints')
          // console.log(cuePoints)
          $.each(cuePoints, function (index, value) {
            self.player.removeCuePoint(value.id)
          })
        })

        this.player.loadVideo(this.videoId).then(function () {
          console.log('the video was loaded')
        }).catch(function (error) {
          console.log('an error occurred' + error)
        })
        this.$emit('change-video-desc')

        Cookies.set('captureCount', 0)
        this.isSetCues = false
        this.pauseTimestamp = 0
      }
    },
    setEndedWebcamCapture (event) {
      Cookies.set(this.videoName, 0)
      if (this.topicVideoFaceCapture) {
        var self = this
        navigator.mediaDevices.getUserMedia(this.constraints).then(function (stream) {
          self.showWebcam = true
          self.captureCount++
          Cookies.set('captureCount', self.captureCount)
          console.log('captureCount: ' + self.captureCount + ' == video ended')
        }).catch(function (err) {
          console.log(err)
        })
      }
      this.isVideoEnded = true
    },
    setProgress (event) {
      this.player.setCurrentTime(event.target.value)
    },
    saveCurrentProgress (event) {
      Cookies.set(this.videoName, event.seconds)
    },
    setToStart () {
      Cookies.set(this.videoName, 0)
      this.player.setCurrentTime(0)
      this.counterValue = 0
    }
  }
}
</script>

<style scoped>
.subject_icon_block {
    height: 100%;
}

.custom-player__time-duration--text {
  color : #fff;
}

@media (max-width:767px) {
  .video_overlay_wrapper {
    height: 70% !important;
  }

  input[type=range] {
    -webkit-appearance: none;
    width: 80% !important;
  }

  .btn__player-custom {
    padding: 6px !important;
  }

}

@media (min-width:768px) and (max-width:1024px){
    .video_overlay_wrapper {
      height: 90% !important;
    }

     .btn__player-custom {
        padding: 8px !important;
    }
}

@media (max-width:1024px) {
   .custom-player__time-duration--text {
      color : #f7941d !important;
    }
}

.btn__player-custom {
  background: #f7941d !important;
  color: #fff !important;
  font-family: 'Roboto', sans-serif !important;
  border-color: #f7941d;
  border-radius:100%;
  padding: 10px;
}

input[type=range] {
  -webkit-appearance: none;
  width: 30%;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  box-shadow: 0px 0px 0px #000000;
  background: #f7941d;
  border-radius: 1px;
  border: 0px solid #000000;
}
input[type=range]::-webkit-slider-thumb {
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #f7941d;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #FFF;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -7px;
}
input[type=range]:focus::-webkit-slider-runnable-track {
  background: #f7941d;
}
</style>
